// extracted by mini-css-extract-plugin
module.exports = {"promotionalTilesComponent":"uz","promotionalTile":"uA","promotionalTileThumb":"uB","promotionalTileHeader":"uC","promotionalTileCaption":"uD"};